// 部门人员参照
/* global $ u */
import Collection from 'common/vo/collection'
/* eslint-disable no-unused-vars */
import person from 'collection/person'
import department from 'collection/department'
/* eslint-disable no-unused-vars */
import {Get, Post} from 'common'
let orgInfo
let setorgInfo = async function () {
  let data = await Get('/cpu-supplymgr/supplyMgrEvaluate/evaluateGroup/select')
  orgInfo = {
    'orgId': data.data.orgInfo.orgId,
    'orgName': data.data.orgInfo.orgName
  }
}
setorgInfo()

function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  let collection = Collection.create('collection.person')
  collection.load({
    organizationid: orgInfo.orgId,
    pageIndex: 0,
    pageSize: 10
  })
  let vm = {
    config: {
      'id': 'gridperson',
      'data': collection,
      'type': 'grid',
      'multiSelect': false,
      'editable': false,
      pagination: true,
      fields: [{
        'field': 'personname',
        'dataType': 'String',
        'title': '人员',
        'width': '50%'
      }, {
        'field': 'personcode',
        'dataType': 'String',
        'title': '编码',
        'width': '50%'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#evaluatorrefer')[0])
  refer.registerSubmitFunc(() => {
    let selectData = collection.datatable.getCurrentRow().data
    // console.log(selectData)
    return {
      id: selectData.id.value,
      personname: selectData.personname.value,
      personcode: selectData.personcode.value,
      organizationid: selectData.organizationid.value,
      userid: selectData.userid.value,
      username: selectData.username.value,
      enterpriseId: selectData.enterpriseId.value,
      organizationname: orgInfo.orgName
    }
  })
  collection.datatable.on('select', function (obj) {
    refer.submit()
  })
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/evaluator/index.js